export function hasTimeWindow(start: number, end: number) {
    return start > 0 || (end > 0 && end < 2400);
}

export function secondsOfDayToTimeInt(seconds: number) {
    const hours = Math.floor(seconds / 3600) % 24;
    const mins = Math.floor((seconds % 3600) / 60);
    return hours * 100 + mins;
}

export function isEtaAfterWindowEnd(etaSeconds: number, windowEnd: number) {
    return windowEnd > 0 && windowEnd < 2400 && secondsOfDayToTimeInt(etaSeconds) > windowEnd;
}

/** How many minutes a planned arrival lands after the window's end; 0 inside it or without an end. */
export function minutesAfterWindowEnd(etaSeconds: number, windowEnd: number) {
    if (!isEtaAfterWindowEnd(etaSeconds, windowEnd)) {
        return 0;
    }
    const eta = Math.floor(etaSeconds / 60) % (24 * 60);
    const end = Math.floor(windowEnd / 100) * 60 + windowEnd % 100;
    return eta - end;
}

/** A clock time (930 for 9:30) as seconds into the day. */
export function timeIntToSeconds(time: number) {
    return Math.floor(time / 100) * 3600 + (time % 100) * 60;
}

/**
 * A job's window lies wholly outside a shift given in seconds into the day: it opens at or after the shift's end, or
 * closes at or before its start. A shift over midnight isn't judged.
 */
export function isWindowOutsideShift(windowStart: number, windowEnd: number, shiftStartSec: number, shiftEndSec: number) {
    if (!hasTimeWindow(windowStart, windowEnd) || shiftEndSec <= shiftStartSec) {
        return false;
    }
    const opens = timeIntToSeconds(windowStart);
    const closes = windowEnd > 0 && windowEnd < 2400 ? timeIntToSeconds(windowEnd) : 24 * 3600;
    return opens >= shiftEndSec || closes <= shiftStartSec;
}

/** Seconds into the day as a clock time (930 for 9:30), at most midnight. */
export function clockTime(seconds: number) {
    return Math.min(2400, Math.floor(seconds / 3600) * 100 + Math.floor((seconds % 3600) / 60));
}

/** Seconds into the day as a clock time on the full hour at or after it, at most midnight. */
export function fullHourAfter(seconds: number) {
    return Math.min(2400, Math.ceil(seconds / 3600) * 100);
}
